import { useEffect, useState } from "react";
import { api } from "@/lib/api";

/**
 * Global site settings cache. One network call per app load.
 * Missing fields fall back to sensible placeholders so pages never render
 * an empty phone / email while data is loading.
 */
let _cache = null;
let _promise = null;
const listeners = new Set();

const FALLBACK = {
  contact_email: "",
  contact_phone: "",
  whatsapp: "",
  telegram: "",
  address_ar: "",
  address_en: "",
  working_hours_ar: "",
  working_hours_en: "",
  linkedin_url: "",
  twitter_url: "",
  instagram_url: "",
  youtube_url: "",
  tax_id: "",
  cr_number: "",
};

async function fetchOnce() {
  if (_cache) return _cache;
  if (_promise) return _promise;
  _promise = api.get("/site-settings").then((r) => {
    _cache = { ...FALLBACK, ...(r.data || {}) };
    listeners.forEach((cb) => cb(_cache));
    return _cache;
  }).catch(() => {
    _cache = { ...FALLBACK };
    return _cache;
  }).finally(() => { _promise = null; });
  return _promise;
}

export function refreshSiteSettings(next) {
  _cache = { ...FALLBACK, ...(next || {}) };
  listeners.forEach((cb) => cb(_cache));
}

export function useSiteSettings() {
  const [settings, setSettings] = useState(_cache || FALLBACK);
  useEffect(() => {
    let mounted = true;
    fetchOnce().then((c) => { if (mounted) setSettings(c); });
    const cb = (c) => { if (mounted) setSettings(c); };
    listeners.add(cb);
    return () => { mounted = false; listeners.delete(cb); };
  }, []);
  return settings;
}
